// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"72bdd4ad","143":"f4f4e196","300":"f3d5bc6e","318":"1dbd8ae9","561":"88b4088d","787":"a663bc8e","822":"b74caa23","963":"737575ed"}[chunkId] + ".chunk.js";
};